var map = {
	"./1.png": "e4e1",
	"./2.png": "575a",
	"./3.png": "9496",
	"./4.png": "2b11",
	"./icon1.png": "6b7d",
	"./icon2.png": "a4aa",
	"./icon3.png": "3026"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a6b";